'use client'

import { createContext, useEffect, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom-v5'
import { AnalyticsPlatforms, getAnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { sendPageViewEvent } from '../events/sendPageViewEvent'

export const AnalyticsContext = createContext(null)

export interface AnalyticsProviderProps {
  children: ReactNode
}

/**
 * 只有用在 SPA 要切換頁面時才需要使用，如果是在 SSR 的頁面，請使用其他方式來發送頁面瀏覽事件
 */
export const AnalyticsProvider = (props: AnalyticsProviderProps) => {
  const { children } = props
  const location = useLocation()

  useEffect(function sendRoutePageView() {
    const platforms = getAnalyticsPlatforms().filter(platform => platform !== AnalyticsPlatforms.ALETHEIA)
    sendPageViewEvent({
      page_title: document.title,
      page_location: location.pathname + location.search,
    }, platforms)
  }, [location.pathname, location.search])

  return (
    <AnalyticsContext.Provider value={null}>
      {children}
    </AnalyticsContext.Provider>
  )
}
